import type { App } from '../App';

export interface GetDebugGameWindow {
  resetState: () => void;
}

const gameWindow: GetDebugGameWindow = window as unknown as GetDebugGameWindow;

export function getDebugGameWindow(app: App): GetDebugGameWindow {
  gameWindow.resetState = async (): Promise<void> => {
    await app.stateController.resetState();
    await app.platform.flushDataAsync();
    document.location.reload();
  };
  return gameWindow;
}
